import styled from '@emotion/styled'
import { ExtranetContainer, MediaQuery } from '@pharmac-extranet/shared'
import { useIsAuthorized } from '../../router/RouteGuards'
import { FrontpageNewsletters } from './FrontpageNewsletters'
import { FrontpageShortcuts } from './FrontpageShortcuts'

const FrontpageGridRoot = styled.div`
  display: grid;

  width: 100%;

  grid-template-columns: 70% 30%;
  grid-template-rows: 100%;

  ${MediaQuery.maxTablet} {
    grid-template-rows: auto auto;
    grid-template-columns: 100%;
  }
`

const FrontpageNewslettersRoot = styled.div<{ fullWidth?: boolean }>`
  grid-area: ${(p) => (p.fullWidth ? '1 / 1 / 2 / 2' : '1 / 1 / 2 / 3')};

  ${MediaQuery.maxTablet} {
    grid-area: 2 / 1 / 3 / 2;
  }
`
const FrontpageShortcutsRoot = styled.div`
  grid-area: 1 / 2 / 2 / 3;

  ${MediaQuery.maxTablet} {
    grid-area: 1 / 1 / 2 / 2;
  }
`

export const FrontpageCustomerContent = () => {
  const authResult = useIsAuthorized({
    doseDispensingPharmacy: true,
    customerViewOrders: true,
  })

  const isDoseDispensingCustomer = authResult === true

  return (
    <ExtranetContainer
      full
      paddingSmallHorizontal
    >
      <FrontpageGridRoot>
        <FrontpageNewslettersRoot fullWidth={isDoseDispensingCustomer}>
          <FrontpageNewsletters isDoseDispensingCustomer={isDoseDispensingCustomer} />
        </FrontpageNewslettersRoot>
        {isDoseDispensingCustomer && (
          <FrontpageShortcutsRoot>
            <FrontpageShortcuts />
          </FrontpageShortcutsRoot>
        )}
      </FrontpageGridRoot>
    </ExtranetContainer>
  )
}
